<template>
  <v-list-tile v-if="!isEditing" avatar ripple class="it-hv">
    <v-list-tile-avatar>
      <font-awesome-icon :icon="['fal', 'baby']"></font-awesome-icon>
    </v-list-tile-avatar>
    <v-list-tile-content>
      <v-list-tile-sub-title class="caption" v-if="!isPrintEmpty">出生地</v-list-tile-sub-title>
      <v-list-tile-title>{{ printBirthplace }}</v-list-tile-title>
    </v-list-tile-content>
    <v-list-tile-action>
      <v-tooltip bottom>
        <v-btn flat icon slot="activator" class="blue--text text--darken-2" :loading="isThisLoading" @click="edit"><font-awesome-icon :icon="['fal', 'pencil']"/></v-btn>
        <span>編集する</span>
      </v-tooltip>
    </v-list-tile-action>
  </v-list-tile>
  <v-container v-else>
    <v-layout wrap class="pb-4">
      <v-flex xs12 class="px-3">
        <v-text-field counter required
          label="出生地"
          :rules="rules.birthplace"
          maxlength="50"
          v-model="form.birthplace.content"></v-text-field>
      </v-flex>
    </v-layout>
    <v-divider></v-divider>
  </v-container>
</template>

<script>
export default {
  name: 'clientAboutBasicBirthplace',
  components: {
  },
  props: [
    'status',
    'data'
  ],
  data () {
    return {
      form: {
        birthplace: {
          id: '',
          content: ''
        }
      },
      rules: {
        birthplace: [
          v => !!v || '必須項目です'
        ]
      }
    }
  },
  methods: {
    prepare: function () {
      if (
        this.$props.data &&
        this.$props.data.birthplace
      ) {
        this.$set(this.form, 'birthplace', {
          id: '' + (this.$props.data.birthplace.id ? this.$props.data.birthplace.id : 'new_birthplace'),
          content: this.$props.data.birthplace.content ? this.$props.data.birthplace.content : ''
        })
      } else {
        this.$set(this.form, 'birthplace', {
          id: 'new_birthplace',
          content: ''
        })
      }
    },
    edit: function () {
      this.prepare()
      this.$emit('emit', {
        action: 'edit',
        data: {
          type: 'birthplace'
        }
      })
    },
    getForm: function () {
      return this.form
    }
  },
  computed: {
    isEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        ['birthplace', 'all'].includes(this.$props.status.editing)
      )
    },
    isThisEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        this.$props.status.editing === 'birthplace'
      )
    },
    isLoading () {
      return !!(
        this.$props.status &&
        this.$props.status.loading &&
        ['birthplace', 'all'].includes(this.$props.status.loading)
      )
    },
    isThisLoading () {
      return !!(
        this.$props.status &&
        this.$props.status.loading &&
        this.$props.status.loading === 'birthplace'
      )
    },
    printBirthplace () {
      return (
        this.$props.data &&
        this.$props.data.birthplace &&
        this.$props.data.birthplace.content
      ) ? this.$props.data.birthplace.content : '出生地'
    },
    isPrintEmpty () {
      return !(
        this.$props.data &&
        this.$props.data.birthplace &&
        this.$props.data.birthplace.content
      )
    }
  }
}
</script>
